import React, { useState, useEffect } from "react";
import {
  Button, Dialog, DialogContent, IconButton,
  TextField, Typography, Stack,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const OlympiadDateModal = ({ onClose, fetchData, propData }) => {
  const [loading, setLoading] = useState(false);
  const [examDate, setExamDate] = useState("");
  const [lastRegistrationDate, setLastRegistrationDate] = useState("");
  const [registrationFee, setRegistrationFee] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (propData) {
      // Convert ISO string to "YYYY-MM-DD" for date input
    //   setExamDate(propData.exam_date ? propData.exam_date.substring(0, 10) : "");
setExamDate(propData.exam_date ? new Date(propData.exam_date).toLocaleDateString("en-CA") : "");
      setLastRegistrationDate(
        propData.last_registration_date
          ? propData.last_registration_date.substring(0, 10)
          : ""
      );
      setRegistrationFee(propData.registration_fee || "");
      setDescription(propData.description || "");
    }
  }, [propData]);

  const submitHandler = async () => {
    if (!examDate) {
      window.NotificationUtils.showError("Please select an Exam Date");
      return;
    }
    // if (!lastRegistrationDate) {
    //   window.NotificationUtils.showError("Please select a Last Registration Date");
    //   return;
    // }
    // if (!registrationFee) {
    //   window.NotificationUtils.showError("Please enter Registration Fee");
    //   return;
    // }

    setLoading(true);
    try {
      const payload = {
        exam_date: examDate,
        last_registration_date: lastRegistrationDate,
        registration_fee: registrationFee,
        description: description,
      };

      if (propData) {
        await window.Platform.database.updateOlympiadDate({
          ...payload,
          id: propData.id,
        });
        window.NotificationUtils.showSuccess("Olympiad Date updated successfully");
      } else {
        await window.Platform.database.addOlympiadDate(payload);
        window.NotificationUtils.showSuccess("Olympiad Date saved successfully");
      }

      fetchData();
      onClose();
    } catch (err) {
      window.NotificationUtils.showError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">
            {propData ? "Update Olympiad Date" : "Add Olympiad Date"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>

        {loading && <OpaqueLoading />}

        <Stack gap={2} padding={2}>
          <TextField
            label="Exam Date"
            type="date"
            value={examDate}
            onChange={(e) => setExamDate(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Registration Fee"
            type="number"
            value={registrationFee}
            onChange={(e) => setRegistrationFee(e.target.value)}
            fullWidth
            inputProps={{ min: 0 }}
          />
{/* 
          <TextField
            label="Last Registration Date"
            type="date"
            value={lastRegistrationDate}
            onChange={(e) => setLastRegistrationDate(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            multiline
            rows={3}
          /> */}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              color="primary"
              variant="contained"
              onClick={submitHandler}
              disabled={!examDate}
            >
              {propData ? "Update" : "Create"}
            </Button>
          </div>
        </Stack>
      </StyledDialogContent>
    </Dialog>
  );
};

export default OlympiadDateModal;